import { connect } from 'react-redux'
import CommentsComponent from 'pages/comments/CommentsComponent'
import { setAnnotationsCommentsLoaded, setAnnotationsLoaded } from 'redux/actions'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  aol: state.aol.name,
  commentMap: state.qa.commentMap
})

const mapDispatchToProps = dispatch => ({
  setCommentsLoaded: isLoaded => dispatch(setAnnotationsCommentsLoaded(isLoaded)),
  setAnnotationsLoaded: isLoaded => dispatch(setAnnotationsLoaded(isLoaded))
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentsComponent)
